module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn green margin-bottom-10",
    on: {
      "click": function($event) {
        _vm.showAddFormModal = true
      }
    }
  }, [_vm._v("Add New")]), _vm._v(" "), (!_vm.loading) ? _c('base-form-index', {
    attrs: {
      "show-share-url": true,
      "loading": _vm.loading,
      "rows": _vm.rows,
      "columns": _vm.columns
    },
    on: {
      "form-removed": _vm.fetchReferralForms
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddFormModal) ? _c('add-form-modal', {
    attrs: {
      "modules": [_vm.module],
      "preselectedModule": _vm.module.key
    },
    on: {
      "hide": function($event) {
        _vm.showAddFormModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-038e0456","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/indexes/ReferralFormsIndex.vue
// module id = 1537
// module chunks = 1